import { render, staticRenderFns } from "./pc-header.component.vue?vue&type=template&id=59f97e5c&scoped=true&"
import script from "./pc-header.component.vue?vue&type=script&lang=js&"
export * from "./pc-header.component.vue?vue&type=script&lang=js&"
import style0 from "./pc-header.component.vue?vue&type=style&index=0&id=59f97e5c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f97e5c",
  null
  
)

export default component.exports